import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { ContentStyle, InfoAlert } from "../../Theme";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { useCallback, useEffect, useState } from "react";
import IDMELogo from "../../images/icons/IDme.svg";
import CloseIcon from "@mui/icons-material/Close";
import {
  deleteProfileSettingsDetails,
  getProfileSettingsDetails,
  saveAsPreferenceApi,
} from "../../Apis/Idme2FA";
import YSSnackBar from "../../uikit/YSSnackBar";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import EPCSIdProofing from "../../components/EPCSIdProofing";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import AlertInfoIcon from "../../images/icons/AlertInfoIcon.svg";

export default function ProfileSettings() {
  // const PrescriberDetailsState = useSelector((state: any) => {
  //   return { ...state.PrescriberDetailsSlice };
  // }); //redux data
  // const { AllPrescriberDetails } = PrescriberDetailsState;
  // const { idProofingRequired } = AllPrescriberDetails;
  const [searchParams] = useSearchParams();
  const verificationStatus: any = searchParams.get("verification_status");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>("");
  const [data, setData] = useState<any>(null);
  const [checked, setChecked] = useState(false);
  const [redirectToIdme, setRedirectToIdme] = useState<boolean | null>(null);
  const [defaultPharmacySearchStateMode, setDefaultPharmacySearchStateMode] =
    useState<boolean | null>(null);
  const [snackbar, setSnackbar] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  });
  const [idProof, setIdProof] = useState(false);
  const handleHideIdProofPopupClick = () => {
    setIdProof(false);
  };
  const handleShowIdProofPopupClick = () => {
    // if (idProofingRequired) {
    //   setIdProof(true);
    // }
    setIdProof(true);
  };
  const deletePreferences = async () => {
    try {
      const params: any = new URLSearchParams();
      params.append("personId", localStorage.getItem("doctorId"));
      params.append("settingType", "MFA_SETUP");
      const result = await deleteProfileSettingsDetails(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData({ ...data, mfaDeviceSetUpDescription: "" });
        setSnackbar((prevState: any) => {
          return {
            ...prevState,
            message: "Deleted your ID.me MFA Setup successfully!",
            variant: "success",
            open: true,
          };
        });
      } else {
        setSnackbar((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setSnackbar((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong, try again after sometime.",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const changeQuickNav = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      setChecked(event.target.checked);
      const body = {
        settingType: "QNAVRX",
        enabled: event.target.checked,
        savedPreference: "0",
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        setSnackbar((prevState: any) => {
          return {
            ...prevState,
            message: "Quick Navigation changed successfully!",
            variant: "success",
            open: true,
          };
        });
      } else {
        setChecked(checked);
        setSnackbar((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setChecked(checked);
      setSnackbar((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong, try again after sometime.",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const changeRoute = async (
    event: React.ChangeEvent<HTMLInputElement>,
    settingType: string,
    savedPreference: string
  ) => {
    try {
      if (settingType === "MFA_ROUTE") {
        setRedirectToIdme(event.target.checked);
      } else if (settingType === "DEF_PH_ST") {
        setDefaultPharmacySearchStateMode(event.target.checked);
      }
      const body = {
        settingType,
        enabled: true,
        // savedPreference: redirectToIdme ?   "0" : "1",
        savedPreference,
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        setSnackbar((prevState: any) => {
          return {
            ...prevState,
            message:
              settingType === "MFA_ROUTE"
                ? "Route preference saved successfully!"
                : "Pharmacy Grouping Preference saved successfully!",
            variant: "success",
            open: true,
          };
        });
      } else {
        setRedirectToIdme(redirectToIdme);
        setDefaultPharmacySearchStateMode(defaultPharmacySearchStateMode);
        setSnackbar((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setRedirectToIdme(redirectToIdme);
      setDefaultPharmacySearchStateMode(defaultPharmacySearchStateMode);
      setSnackbar((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong, try again after sometime.",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const getProfileDetails = useCallback(async () => {
    try {
      const result: any = await getProfileSettingsDetails();
      if (result?.data?.digitalRxStatusCode === 200) {
        setDefaultPharmacySearchStateMode(
          result?.data?.response[0]?.defaultPharmacySearchStateMode === "1"
            ? true
            : false
        );
        // setProfileSettingsAlert((prevState: any) => {
        //   return {
        //     ...prevState,
        //     open: result?.data?.response[0]?.defaultPharmacySearchStateMode,
        //   };
        // });
        if (result?.data?.response[0]?.quickNavigationEnabled) {
          setChecked(true);
        } else {
          setChecked(false);
        }

        if (result?.data?.response[0]?.mfaRouteEnabled === "1") {
          setRedirectToIdme(true);
        } else if (result?.data?.response[0]?.mfaRouteEnabled === "0") {
          setRedirectToIdme(false);
        } else {
          setRedirectToIdme(null);
        }
        setData(result?.data?.response[0]);
        setLoading(false);
      } else {
        setError(result?.data?.digitalRxStatusMessage);
        setLoading(false);
      }
    } catch (error) {
      setError("Something went wrong!");
      setLoading(false);
    }
  }, []);

  const checkStatusOfEpcsIdProofing = () => {
    if (verificationStatus === "1" || verificationStatus === "2") {
      setIdProof(true);
    } else {
      setIdProof(false);
    }
  };

  useEffect(() => {
    getProfileDetails();
    checkStatusOfEpcsIdProofing();
  }, []);

  return (
    <ContentStyle>
      <Typography className="help" component="h6" color="primary" variant="h6">
        Profile Settings{" "}
        <HelpGuideTooltip
          content={
            <>
              <Typography component="div" variant="body1">
                You can customize or revise your profile settings here.
              </Typography>
            </>
          }
        />
      </Typography>
      <Grid container border={"1px solid #ccc"} borderRadius={2}>
        <InfoAlert>
          <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
          <Typography component="span" variant="body2" fontWeight={600}>
            Note: Updating your profile settings will require you to log in
            again.
          </Typography>
        </InfoAlert>
      </Grid>
      {loading ? (
        <Grid
          container
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"50vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      ) : error ? (
        <Grid
          container
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"50vh"}
        >
          <Typography variant="subtitle1" color="error">
            {error}
          </Typography>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" marginBottom={1}>
              Integrated Login Quick Navigation
            </Typography>

            <Box
              sx={{
                background: "#EBF1F4",
                border: "1px solid #44799C",
                borderRadius: 2,
                padding: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  spacing: 2,
                }}
              >
                <Typography variant="body2" lineHeight={1.4}>
                  Enable this setting to streamline your login experience by
                  bypassing the popup for quick navigation. When activated,
                  users will be directed straight to the RxPad upon login,
                  bypassing the intermediate popup for seamless access to
                  medication management. If you prefer a direct route to your
                  prescription pad without interruptions, toggle this setting to
                  "On." If you enjoy the convenience of choosing specific
                  sections after login, keep it toggled "Off" to continue
                  utilizing the popup navigation.
                </Typography>
                <Switch
                  name="mfaRoute"
                  checked={checked}
                  onChange={changeQuickNav}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Box>
            </Box>
          </Grid>
          {data?.emailId && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" marginBottom={1}>
                Connected Accounts
              </Typography>

              <Box
                sx={{
                  background: "#EBF1F4",
                  border: "1px solid #44799C",
                  borderRadius: 2,
                  padding: 2,
                }}
              >
                <Box sx={{ marginBottom: 1 }}>
                  <img src={IDMELogo} alt="ID.me" height={20} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 2,
                    marginBottom: 1.5,
                  }}
                >
                  <Typography variant="body2" fontWeight={600}>
                    Email:{" "}
                  </Typography>
                  <Typography variant="body2">{data?.emailId}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 2,
                    marginBottom: 1,
                  }}
                >
                  <Typography variant="body2" fontWeight={600}>
                    ID Proofing Status:{" "}
                  </Typography>
                  {data?.erxIdProofed && (
                    <Typography
                      variant="body2"
                      paddingX={0.5}
                      borderRadius={1}
                      border={"1px solid grey"}
                    >
                      eRx
                    </Typography>
                  )}
                  {UserServiceState?.npi !== null && data?.epcsIdProofed && (
                    <Typography
                      variant="body2"
                      paddingX={0.5}
                      borderRadius={1}
                      border={"1px solid grey"}
                    >
                      EPCS
                    </Typography>
                  )}
                </Box>
                {redirectToIdme !== null && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 2,
                      marginBottom: 1,
                    }}
                  >
                    <Typography variant="body2" fontWeight={600}>
                      ID.me MFA Route:{" "}
                    </Typography>{" "}
                    <Typography variant="body2">Redirect to ID.me</Typography>{" "}
                    <Switch
                      name="idme"
                      checked={redirectToIdme ?? false}
                      onChange={(event) =>
                        changeRoute(
                          event,
                          "MFA_ROUTE",
                          redirectToIdme ? "0" : "1"
                        )
                      }
                      size="small"
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <Typography variant="body2">
                      Complete with in H2H
                    </Typography>
                  </Box>
                )}
                {data?.mfaDeviceSetUpDescription && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 2,
                      marginBottom: 1,
                    }}
                  >
                    <Typography variant="body2" fontWeight={600}>
                      ID.me MFA Setup:
                    </Typography>{" "}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        border: "1px solid grey",
                        borderRadius: 1,
                        paddingX: 0.5,
                      }}
                    >
                      <Typography variant="body2">
                        {data?.mfaDeviceSetUpDescription}
                      </Typography>

                      <IconButton
                        sx={{ padding: 0 }}
                        onClick={deletePreferences}
                      >
                        <CloseIcon color="error" fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="subtitle1" marginBottom={1}>
              Default Pharmacy Grouping Preference
            </Typography>

            <Box
              sx={{
                background: "#EBF1F4",
                border: "1px solid #44799C",
                borderRadius: 2,
                padding: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  gap: 2,
                }}
              >
                <Box>
                  <Typography variant="body2" lineHeight={1.4}>
                    Choose how you'd like pharmacies to be grouped by default
                    when viewing options:
                  </Typography>
                  <Typography variant="body2" lineHeight={1.4}>
                    Group pharmacies based on either the{" "}
                    <strong>Doctor's Clinic Location State </strong> or the{" "}
                    <strong>Patient's Location State.</strong>
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={2}>
                  <Typography variant="body2" fontWeight={600}>
                    Group by:
                  </Typography>{" "}
                  <Typography variant="body2">
                    Doctor's Clinic Location State 
                  </Typography>{" "}
                  <Switch
                    name="pharmState"
                    checked={defaultPharmacySearchStateMode ?? false}
                    onChange={(event) =>
                      changeRoute(
                        event,
                        "DEF_PH_ST",
                        defaultPharmacySearchStateMode ? "0" : "1"
                      )
                    }
                    size="small"
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <Typography variant="body2">
                    Patient's Location State
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          {/* Display EPCS Proofing when epcsIdProofed is false */}
          {UserServiceState?.npi !== null && !data?.epcsIdProofed && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" marginBottom={1}>
                EPCS ID Proofing
              </Typography>

              <Box
                sx={{
                  background: "#EBF1F4",
                  border: "1px solid #44799C",
                  borderRadius: 2,
                  padding: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    spacing: 2,
                  }}
                >
                  <Typography variant="body2" lineHeight={1.4}>
                    Complete EPCS ID Proofing to get access of EPCS
                  </Typography>
                  <YSButton
                    color="primary"
                    component={"div"}
                    size="medium"
                    children="Complete EPCS ID Proofing"
                    id="btnEpcsIdProofing"
                    type="button"
                    variant="contained"
                    onClick={() => {
                      handleShowIdProofPopupClick();
                    }}
                    className=""
                  />
                </Box>
                <DialogPopup
                  title="One more step to get your account created"
                  windowsize={"md"}
                  show={idProof}
                  handleShowPopupClick={handleShowIdProofPopupClick}
                  handleHidePopupClick={handleHideIdProofPopupClick}
                >
                  <EPCSIdProofing
                    handleHideIdProofPopupClick={handleHideIdProofPopupClick}
                    getProfileDetails={getProfileDetails}
                  />
                </DialogPopup>
              </Box>
            </Grid>
          )}
        </Grid>
      )}
      <YSSnackBar
        message={snackbar.message}
        variant={snackbar.variant}
        open={snackbar.open}
        handleClose={() => {
          setSnackbar((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </ContentStyle>
  );
}
